
import { IPushbackReport } from "../../../models/configuration/pushback/IPushbackReport";
import { Action, ActionType } from "../../actions";

interface PushbackReportState {
  loading: boolean;
  error: string | null;
  data: IPushbackReport | null;
}

const initialState = { loading: false, error: null, data: null };

const pushbackReportReducer = (
  state: PushbackReportState = initialState,
  action: Action
): PushbackReportState => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_PUSHBACK_REPORT:
      return { ...state, loading: true, error: null };
    case ActionType.GET_PUSHBACK_REPORT_FAILURE:
        return { ...state, loading: false, error: action.payload };
    case ActionType.GET_PUSHBACK_REPORT_SUCCESS:
        return { ...state, loading: false, error: null, data: action.payload };
    case ActionType.CONFIG_ID_CHANGED:
        return initialState;
    default:
        return state;
  }
};

export default pushbackReportReducer;